// extracted by css-extract-rspack-plugin
export default {"tokenField":"rj1CI"};